import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { Page404Component } from "./authentication/page404/page404.component";
import { AuthGuard } from "./core/guard/auth.guard";
import { Role } from "./core/models/role";
import { AuthLayoutComponent } from "./layout/app-layout/auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./layout/app-layout/main-layout/main-layout.component";
import { PatientQueuingStatusComponent } from "./patient-queuing/patient-queuing-status/patient-queuing-status.component";
import { PatientLayoutComponent } from "./patient-queuing/layout/patient-layout.component";
import { PrintPageComponent } from "./print-page/print-page.component";
import { SigninComponent } from "./authentication/signin/signin.component";
import { LoginGuard } from "./core/guard/login.guard";
const routes: Routes = [

  {
    path: "",
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "", redirectTo: "/authentication/signin", pathMatch: "full" },
      {
        path: "admin",
        canActivate: [AuthGuard],
        data: {
          role: Role.Admin,
        },
        loadChildren: () =>
          import("./admin/admin.module").then((m) => m.AdminModule),
      },
      {
        path: "extra-pages",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./extra-pages/extra-pages.module").then(
            (m) => m.ExtraPagesModule
          ),
      },
      {
        path: "multilevel",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./multilevel/multilevel.module").then(
            (m) => m.MultilevelModule
          ),
      },
      {
        path: "prpo",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./prpo/prpo.module").then((m) => m.PRPOModule),
      },
      {
        path: "patientscare",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./patients-care/patients-care.module").then(
            (m) => m.PatientsCareModule
          ),
      },
      {
        path: "billing",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./billing/billing.module").then((m) => m.BillingModule),
      },
      {
        path: "accounting",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./Accounting/accounting.module").then(
            (m) => m.AccountingModule
          ),
      },
      {
        path: "coremodule",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./coremodule/coremodule.module").then(
            (m) => m.CoremoduleModule
          ),
      },
      {
        path: "hrms",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./hrms/hrms.module").then((m) => m.HrmsModule),
      },
      {
        path: "officeadmin",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./OfficeAdmin/officeadmin.module").then(
            (m) => m.OfficeadminModule
          ),
      },
      {
        path: "inventory-management",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./inventory-management/inventory-management.module").then(
            (m) => m.InventoryManagementModule
          ),
      },
    ],
  },
  {
    path: "authentication",
    component: AuthLayoutComponent,
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: "patientQueuing",
    canActivate: [AuthGuard],
    component: PatientLayoutComponent,
    loadChildren: () =>
      import("./patient-queuing/patient-queuing.module").then(
        (m) => m.PatientQueuingModule
      ),
  },
  { path: "print/:id", component: PrintPageComponent },
  { path: "**", component: Page404Component },
  // { path: 'patientQueuingStatus', canActivate: [AuthGuard], component: PatientQueuingStatusComponent },
  // 4. Wildcard Route (Optional): Catch-all redirect

];
@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
